import { SystemRoles, DynamicSystemRoles } from "models/ApiEnums";

export const LicenseManagerEmail = "licensing@micropowerglobal.com";

export enum RequestLifeCycle {
    None,
    Init, InitSuccess, InitFailed,
    Loading, LoadFailed,
    Posting, PostSuccess, PostFailed,
    PermissionDenied,
    NoUserLicenses
}

export enum AttachType {
    Link,
    Video,
    Image,
    File,
    Publication
}

export enum ImageOrientation {
    Landscape,
    Portrait
}

export interface IDashboardFloatMenuItem {
    name: string;
    path: string;
    icon: any;
    showMode: "temp" | "regular" | "bottom";
    alternativeActionItem?: boolean;
    callout: boolean;
    roles?: SystemRoles;
    dynamicRoles?: DynamicSystemRoles;
    grouping?: number;
    hideIfNoCanViewCourses?: boolean;
    hideIfNoCallout?: boolean;
}

export type DashboadSideMenuLoader = (dispatch: any, data: IDashboardMenu[], leftIndex: number, rightIndex: number) => void;

export interface IDashboardFloatMenu {
    group: string,
    groupButton?: {
        path: string;
        icon: any;
        title?: string;
    };

    roles?: SystemRoles;
    loader?: DashboadSideMenuLoader;
    loaderError?: any;
    loading?: boolean;
    items: IDashboardFloatMenuItem[];

    //#region Controle de Lista

    /**
     * Quantidade de itens exibidos por vez
     **/
    listThreshold?: number;

    /**
     * Índice corrente da lista.
     * Se -1, a lista mostrará apenas os itens "regulares" e um link 'A-Z' para itens "temporários" será exibido.
     **/
    listCurrentIndex?: number;

    /**
     * Usar uma barra para dividir itens "regulars" de itens "temporários"?
     **/
    listUseDivider?: boolean;

    /**
     * Texto usado no link para carregar mais items
     **/
    listOverflowName?: string;

    /**
     * Texto usado no link para carregar mais items
     **/
    listOverflowNameSingular?: string;

    //#endregion
}

export interface IDashboardMenu {
    navbarIcon: any;
    navbarName: string;
    navbarPath?: string;
    groups: IDashboardFloatMenu[];
    prependSpacer: boolean;
    roles?: SystemRoles;
    callout: boolean;
}

export interface ISingleRoute {
    path: string;
    name: string;
    redirectPath?: string;
}

export interface IReducerAction {
    type: string;
    playload: any;
}

export interface IDashboardMenuCalloutUpdate {
    path: string;
    callout: boolean;
}

//=> IDIOMAS
export const Cultures = [
    {
        flag: "brazil",
        cultures: ["pt", "pt-BR"],
        name: "Português"
    },
    //{
    //    flag: "spain",
    //    cultures: ["es", "es-ES"],
    //    name: "Espanol"
    //},
    //{
    //    flag: "usa",
    //    cultures: ["en", "en-US"],
    //    name: "English"
    //}
];